export default "<p>\n  select-element-config works!\n</p>\n";